import { Component, ElementRef, ViewChild, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators,FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { Subject } from "rxjs/Subject";

@Component({
	selector: 'ConfirmarEliminacion',
	templateUrl: 'ConfirmarEliminacion.component.html',
})
export class ConfirmarEliminacion {


	private confirmarEliminacion = new Subject<void>();
	public  eventoFin$ = this.confirmarEliminacion.asObservable();

	public ocultar: boolean = false;
	public mensaje: string = "";

	constructor(private _serviciosGenerales:ServiciosGenerales, private snackBar: MatSnackBar,
		private dialogRef: MatDialogRef<ConfirmarEliminacion>, @Inject(MAT_DIALOG_DATA) private data: any) { }

	onNoClick(): void {
		this.dialogRef.close(false);
		
		this.snackBar.dismiss();
	}


	eliminar(){
		
		this._serviciosGenerales.delete(this.data.ruta, this.data.info).subscribe(
			result =>{

				this.openSnackBar(result.mensaje, "X");

				if(result.error == false)
					this.dialogRef.close(true);

			},
			error =>{
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBar("Ocurrió un error al momento de eliminar el registro", "X");
				this.dialogRef.close(false);
			});
	}

	openSnackBar(message: string, action: string)
	{
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}

	openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {

			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}

}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Dialog/ConfirmarEliminacion.ts